import { Box } from '@wishket/design-system';
import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface ContentContainerProps {
  children: ReactNode;
  className?: string;
}

const ContentContainer = ({ children, className }: ContentContainerProps) => {
  return (
    <Box
      className={twMerge(
        'flex h-[150px] w-full flex-col items-center rounded-2xl bg-w-white px-4 py-5',
        'tablet:w-[278px]',
        'desktop:h-[158px] desktop:w-[324px] desktop:p-6',
        className
      )}
    >
      {children}
    </Box>
  );
};

export default ContentContainer;
